import AtriumApi from "api";

const heartbeatSurveyService = {
  // ============= PUBLIC ROUTES (no auth) =============

  // Get survey by token (public - for guests filling out survey)
  getSurveyByToken: async (token) => {
    try {
      const response = await AtriumApi.get(`/v2/heartbeat/survey/${token}`);
      return response.data;
    } catch (error) {
      console.error("Error fetching survey:", error);
      throw error;
    }
  },

  // Submit survey response (public - for guests)
  submitSurvey: async (token, answers, timeToComplete = null) => {
    try {
      const response = await AtriumApi.post(`/v2/heartbeat/survey/${token}/submit`, {
        answers,
        timeToComplete,
      });
      return response.data;
    } catch (error) {
      console.error("Error submitting survey:", error);
      throw error;
    }
  },

  // ============= QR CODE SURVEY ROUTES (public) =============

  // Get survey by QR code token (public - for QR code visitors)
  getSurveyByQrCode: async (qrToken) => {
    try {
      const response = await AtriumApi.get(`/v2/heartbeat/survey/qr/${qrToken}`);
      return response.data;
    } catch (error) {
      console.error("Error fetching QR survey:", error);
      throw error;
    }
  },

  // Start survey from QR code (creates anonymous user and invitation)
  startQrSurvey: async (qrToken, sessionId, visitorName = null) => {
    try {
      const response = await AtriumApi.post(`/v2/heartbeat/survey/qr/${qrToken}/start`, {
        sessionId,
        visitorName,
      });
      return response.data;
    } catch (error) {
      console.error("Error starting QR survey:", error);
      throw error;
    }
  },

  // Submit spiritual survey with scoring (public - for slider-based surveys)
  submitSpiritualSurvey: async (token, data) => {
    try {
      const response = await AtriumApi.post(`/v2/heartbeat/survey/${token}/submit-spiritual`, {
        answers: data.answers,
        timeToComplete: data.timeToComplete || null,
        sessionId: data.sessionId || null,
        isAnonymous: data.isAnonymous || false,
        followUpRequested: data.followUpRequested || false,
        followUpEmail: data.followUpEmail || null,
        followUpPhone: data.followUpPhone || null,
        followUpName: data.followUpName || null,
      });
      return response.data;
    } catch (error) {
      console.error("Error submitting spiritual survey:", error);
      throw error;
    }
  },

  // Update follow-up contact information (progressive registration)
  updateFollowUpInfo: async (token, contactInfo) => {
    try {
      const response = await AtriumApi.post(`/v2/heartbeat/survey/${token}/follow-up`, {
        email: contactInfo.email || null,
        phone: contactInfo.phone || null,
        name: contactInfo.name || null,
        requestFollowUp: contactInfo.requestFollowUp !== false,
      });
      return response.data;
    } catch (error) {
      console.error("Error updating follow-up info:", error);
      throw error;
    }
  },

  // ============= PROTECTED ROUTES (auth required) =============

  // Manually trigger survey for a user
  triggerSurvey: async (userId) => {
    try {
      const response = await AtriumApi.post("/v2/heartbeat/survey/trigger", {
        userId,
      });
      return response.data;
    } catch (error) {
      console.error("Error triggering survey:", error);
      throw error;
    }
  },

  // Resend survey invitation
  resendSurvey: async (invitationId) => {
    try {
      const response = await AtriumApi.post(
        `/v2/heartbeat/survey/resend/${invitationId}`
      );
      return response.data;
    } catch (error) {
      console.error("Error resending survey:", error);
      throw error;
    }
  },
};

export default heartbeatSurveyService;
